import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "tools/functions";

export const ActivityTags = {
  getPriority: "getPriority",
  getAreas: "getAreas",
  getAreasTransfers: "getAreasTransfers",
  getQueue: "getQueue",
  getActivity: "getActivity",
  getCities: "getCities",
  getCart: "getCart",
};
export const activityBaseApi = createApi({
  reducerPath: "activityApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/",
    prepareHeaders: (headers) => {
      const token = getAuthToken();
      if (token) headers.set("auth-token", token);

      return headers;
    },
  }),
  tagTypes: [...Object.values(ActivityTags)],
  endpoints: () => ({}),
});
